<sw-page class="topdata-reg-attempt-log-list">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.regLog.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="getList">
            {{ $tc('global.default.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            detail-route="topdata.contact.login.reg.log.detail"
            identifier="id"
            @page-change="onPageChange"
        >
            <template #column-attemptType="{ item }">
                <sw-badge variant="info">
                    {{ getAttemptTypeLabel(item.attemptType) }}
                </sw-badge>
            </template>

            <template #column-conflictType="{ item }">
                <sw-badge :variant="getConflictTypeVariant(item.conflictType)">
                    {{ getConflictTypeLabel(item.conflictType) }}
                </sw-badge>
            </template>

            <template #column-createdAt="{ item }">
                {# {{ formatDate(item.createdAt) }} / #}
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>
        </sw-entity-listing>
    </template>

    <template #sidebar>
        <sw-sidebar>
            <sw-sidebar-filter-panel
                entity="tdcl_registration_attempt_log"
                :filters="listFilters"
                @filters-changed="onFiltersChanged"
            />
        </sw-sidebar>
    </template>
</sw-page>
